import {
    httpGetReferringSpecialists,
    HttpGetReferringSpecialistsOptions,
    HttpGetReferringSpecialistsResponse
} from '../http/referring-specialists.http'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'
import {QUERY_KEYS} from '@/queryClient'
import {PaginationResponse} from '@/types'

export const useGetReferringSpecialists = (
    params: HttpGetReferringSpecialistsOptions['params'],
    options?: Omit<UseQueryOptions<HttpGetReferringSpecialistsResponse>, 'queryKey' | 'queryFn'>
) => {
    const [persistedPagination, setPersistedPagination] = useState<PaginationResponse>({
        total: 0,
        lastPage: 1,
        perPage: 50,
        currentPage: 1
    })

    const query = useQuery({
        queryKey: [QUERY_KEYS.REFERRING_SPECIALISTS, params],
        queryFn: () => httpGetReferringSpecialists({params}),
        ...options
    })

    useEffect(() => {
        if (query.isSuccess) {
            setPersistedPagination(query.data.meta)
        }
    }, [query.data?.data.length])

    return {...query, persistedPagination}
}
